module.exports = __webpack_public_path__ + "img/symbol_s08.1408373.svg";